document.addEventListener("DOMContentLoaded", function () {
    e = document.getElementById('create_customer');
    if (e) {
      e.addEventListener("submit", function () {
        var input = document.createElement("input");
        input.type = 'hidden';
        input.name = 'customer[tags]';
        input.value = langTag('customer');
        this.appendChild(input);
      }, true);
    }



    // ajout langue à formulaire inscription newsletter de footer
    e = document.querySelector("div.footer__block.footer__block--newsletter form")
    if (e) {
      e.addEventListener("submit", function () {
        this["contact[tags]"].value = this["contact[tags]"].value + ", " + langTag('contact');
      }, true);
    }

    // ajout langue à formulaire inscription newsletter de popup
    e = document.querySelector("newsletter-popup div form")
    if (e) {
      e.addEventListener("submit", function () {
        this["contact[tags]"].value = this["contact[tags]"].value + ", " + langTag('contact');
      }, true);
    }

});

document.addEventListener("click", function (event) {
  const trigger = event.target.closest("[data-shopify-privacy-preferences], a[href='#cookies']");
  if (!trigger) return;

  const openPreferences = () => {
    if (!window.privacyBanner?.showPreferences) return false;
    window.privacyBanner.showPreferences();
    return true;
  };

  event.preventDefault();
  if (openPreferences()) return;

  let attempts = 0;
  const timer = setInterval(() => {
    attempts += 1;
    if (openPreferences() || attempts > 20) clearInterval(timer);
  }, 100);
});

function langTag() {
    lang = Shopify.locale;
    if (lang === "") {
      lang = "ko";
    }
  
    return "ly#" + lang + "ly#";
  }